import Timer from 'tick-tock';
import Breakpoints from './Breakpoints';

const settings = {
  delay: 500,
  maxWidthPerc: 0.65,
};

export default class GoogleTranslateHelp {
  constructor(element) {
    this.element = element;
    this.settings = settings;
    this.timer = new Timer();
    this.processing = false;
    this.listen();
  }

  onTranslate() {
    if (!this.processing && !Breakpoints.mobileState) {
      this.processing = true;
      this.timer.setTimeout('polling', this.respond.bind(this), this.settings.delay);
    }
  }

  respond() {
    const availableSpace = document.querySelector('.page-header .layout').offsetWidth;
    const elementWidth = this.element.offsetWidth;

    if (elementWidth >= (availableSpace * this.settings.maxWidthPerc)) {
      document.body.classList.add('small-logo');
    } else {
      document.body.classList.remove('small-logo');
    }
    this.timer.clear('polling');
    this.processing = false;
  }

  listen() {
    this.element.addEventListener('DOMSubtreeModified', this.onTranslate.bind(this));
  }
}
